import { render } from "./BuyButton.vue?vue&type=template&id=684c6e96&scoped=true"
import script from "./BuyButton.vue?vue&type=script&lang=js"
export * from "./BuyButton.vue?vue&type=script&lang=js"

import "./BuyButton.vue?vue&type=style&index=0&id=684c6e96&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684c6e96"]])

export default __exports__